import { Action, createReducer, on } from '@ngrx/store';
import {
    lookupAccountManagers,
    lookupAccountManagersFailure,
    lookupAccountManagersSuccess,
    lookupBizDevManagers,
    lookupBizDevManagersFailure,
    lookupBizDevManagersSuccess,
    lookupBrands,
    lookupBrandsFailure,
    lookupBrandsSuccess,
    lookupContractedGroups,
    lookupContractedGroupsFailure,
    lookupContractedGroupsSuccess,
    lookupFacilityTypes,
    lookupFacilityTypesFailure,
    lookupFacilityTypesSuccess,
    lookupHospitalSystems,
    lookupHospitalSystemsFailure,
    lookupHospitalSystemsHierarchy,
    lookupHospitalSystemsHierarchyFailure,
    lookupHospitalSystemsHierarchySuccess,
    lookupHospitalSystemsSuccess,
    lookupStatesFailure,
    lookupStatesSuccess,
    lookupMSPManagers,
    lookupMSPManagersFailure,
    lookupMSPManagersSuccess,
    lookupStates,
    lookupVMSProviders,
    lookupVMSProvidersSuccess
} from './actions/workforce-solutions.actions';
import { WorkforceSolutionsState } from './state/workforce-solutions.state';

export const workforceSolutionsFeatureKey = 'workforce-solutions';

export const initialState: WorkforceSolutionsState = {
    accountManagers: [],
    vmsProviders: [],
    hospitalSystems: [],
    hospitalSystemsHierarchy: [],
    mspManagers: [],
    bizDevManagers: [],
    brands: [],
    contractedGroups: [],
    facilityTypes: [],
    states: null
};

const workforceSolutionsReducer = createReducer(
    initialState,

    on(lookupAccountManagers, (state, action) => ({
        ...state,
        filterText: action.filterText
    })),

    on(lookupAccountManagersSuccess, (state, action) => ({
        ...state,
        accountManagers: action.accountManagers,
        error: undefined
    })),

    //----------------------------------------------------------------------------------------------------------------------------
    on(lookupVMSProviders, (state, action) => ({
        ...state,
        filterText: action.filterText
    })),

    on(lookupVMSProvidersSuccess, (state, action) => ({
        ...state,
        vmsProviders: action.vmsProviders,
        error: undefined
    })),

    //----------------------------------------------------------------------------------------------------------------------------
    on(lookupHospitalSystems, (state, action) => ({
        ...state,
        filterText: action.filterText
    })),

    on(lookupHospitalSystemsSuccess, (state, action) => ({
        ...state,
        hospitalSystems: action.hospitalSystems,
        error: undefined
    })),

    //----------------------------------------------------------------------------------------------------------------------------
    on(lookupHospitalSystemsHierarchy, (state, action) => ({
        ...state
    })),

    on(lookupHospitalSystemsHierarchySuccess, (state, action) => ({
        ...state,
        hospitalSystemsHierarchy: action.hospitalSystemsHierarchy,
        error: undefined
    })),

    //----------------------------------------------------------------------------------------------------------------------------
    on(lookupContractedGroups, (state, action) => ({
        ...state,
        filterText: action.filterText
    })),

    on(lookupContractedGroupsSuccess, (state, action) => ({
        ...state,
        contractedGroup: action.contractedGroups,
        error: undefined
    })),

    //----------------------------------------------------------------------------------------------------------------------------
    on(lookupBrands, (state, action) => ({
        ...state
    })),

    on(lookupBrandsSuccess, (state, action) => ({
        ...state,
        brands: action.brands,
        error: undefined
    })),

    //----------------------------------------------------------------------------------------------------------------------------
    on(lookupBizDevManagers, (state, action) => ({
        ...state,
        filterText: action.filterText
    })),

    on(lookupBizDevManagersSuccess, (state, action) => ({
        ...state,
        bizDevManagers: action.bizDevManagers,
        error: undefined
    })),

    //----------------------------------------------------------------------------------------------------------------------------
    on(lookupMSPManagers, (state, action) => ({
        ...state,
        filterText: action.filterText
    })),

    on(lookupMSPManagersSuccess, (state, action) => ({
        ...state,
        mspManagers: action.mspManagers,
        error: undefined
    })),
    //----------------------------------------------------------------------------------------------------------------------------
    on(lookupFacilityTypes, (state, action) => ({
        ...state
    })),

    on(lookupFacilityTypesSuccess, (state, action) => ({
        ...state,
        mspManagers: action.facilityTypes,
        error: undefined
    })),
    //----------------------------------------------------------------------------------------------------------------------------
    on(lookupStates, (state, action) => ({
        ...state
    })),

    on(lookupStatesSuccess, (state, action) => ({
        ...state,
        states: action.states,
        error: undefined
    })),

    on(
        lookupAccountManagersFailure,
        lookupHospitalSystemsFailure,
        lookupHospitalSystemsHierarchyFailure,
        lookupContractedGroupsFailure,
        lookupBrandsFailure,
        lookupBizDevManagersFailure,
        lookupMSPManagersFailure,
        lookupFacilityTypesFailure,
        lookupStatesFailure,
        (state, action) => ({
            ...state,
            error: JSON.stringify(action.error)
        })
    )
);

export function reducer(state: WorkforceSolutionsState | undefined, action: Action) {
    return workforceSolutionsReducer(state, action);
}
